var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2, _path9, _g3, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCongralutionsImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3614 133.018L160.129 167.376C164.202 168.706 168.067 164.861 166.752 160.785C166.752 160.785 154.755 123.43 145.197 93.6682C138.868 73.9624 133.608 57.5859 133.608 57.5859",
    stroke: "#131416",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3708 131.569C63.2698 138.468 85.8489 127.075 106.802 106.122C127.755 85.1685 139.149 62.59 132.249 55.6904C125.349 48.7909 102.771 60.1843 81.8181 81.1371C60.864 102.091 49.4713 124.67 56.3708 131.569Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.26 61.8191C134.319 59.209 133.674 57.115 132.249 55.6904C125.35 48.7909 102.771 60.1843 81.8183 81.1371C60.8642 102.091 49.4714 124.67 56.371 131.569C63.2699 138.468 85.8491 127.075 106.802 106.122C123.428 89.496 134.035 71.8468 134.26 61.8191Z",
    stroke: "#131416",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.356 88.8471C127.294 86.2003 129.015 83.5627 130.492 80.9755C131.093 79.9662 131.724 78.8075 132.624 77.1406L159.17 159.232L140.05 152.732L144.999 150.876L125.356 88.8471Z",
    fill: "#006779"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.356 88.8471C127.294 86.2003 129.015 83.5627 130.492 80.9755C131.093 79.9662 131.724 78.8075 132.624 77.1406L159.17 159.232L140.05 152.732L144.999 150.876L125.356 88.8471Z",
    fill: "url(#paint0_linear_158_30428)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76367 95.6211C3.10011 95.6211 0.9375 97.7837 0.9375 100.447C0.9375 103.111 3.10011 105.273 5.76367 105.273C8.42724 105.273 10.5898 103.111 10.5898 100.447C10.5898 97.7837 8.42724 95.6211 5.76367 95.6211Z",
    fill: "#006779"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3418 50.3164C59.6782 50.3164 57.5156 52.479 57.5156 55.1426C57.5156 57.8061 59.6782 59.9688 62.3418 59.9688C65.0054 59.9688 67.168 57.8061 67.168 55.1426C67.168 52.479 65.0054 50.3164 62.3418 50.3164Z",
    fill: "#006779"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1172 36.2148C35.4536 36.2148 33.291 38.3775 33.291 41.041C33.291 43.7046 35.4536 45.8672 38.1172 45.8672C40.7808 45.8672 42.9434 43.7046 42.9434 41.041C42.9434 38.3775 40.7808 36.2148 38.1172 36.2148Z",
    fill: "#98C6F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6992 0.769531C50.0357 0.769531 47.873 2.93214 47.873 5.5957C47.873 8.25927 50.0357 10.4219 52.6992 10.4219C55.3628 10.4219 57.5254 8.25927 57.5254 5.5957C57.5254 2.93214 55.3628 0.769531 52.6992 0.769531Z",
    fill: "#006779"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18359 50.5469C1.66156 50.5469 0.425781 51.7827 0.425781 53.3047C0.425781 54.8267 1.66156 56.0625 3.18359 56.0625C4.70563 56.0625 5.94141 54.8267 5.94141 53.3047C5.94141 51.7827 4.70563 50.5469 3.18359 50.5469Z",
    fill: "#006779"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2266 118.574C30.563 118.574 28.4004 120.737 28.4004 123.4C28.4004 126.064 30.563 128.227 33.2266 128.227C35.8901 128.227 38.0527 126.064 38.0527 123.4C38.0527 120.737 35.8901 118.574 33.2266 118.574Z",
    fill: "#98C6F5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.397464
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4766 21.0938C88.9545 21.0938 87.7188 22.3295 87.7188 23.8516C87.7188 25.3736 88.9545 26.6094 90.4766 26.6094C91.9986 26.6094 93.2344 25.3736 93.2344 23.8516C93.2344 22.3295 91.9986 21.0938 90.4766 21.0938Z",
    fill: "#98C6F5"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.338 15.9922C142.674 15.9922 140.512 18.1548 140.512 20.8184C140.512 23.4819 142.674 25.6445 145.338 25.6445C148.001 25.6445 150.164 23.4819 150.164 20.8184C150.164 18.1548 148.001 15.9922 145.338 15.9922Z",
    fill: "#98C6F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.557 43.0756C114.56 36.5134 118.703 33.1406 118.703 33.1406",
    stroke: "#006779",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8215 64.7725C78.7376 56.3585 79.2016 46.2228 82.7578 37",
    stroke: "#98C6F5",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6738 94.6433C70.289 88.6733 54.173 82.4076 32.4235 88.5954",
    stroke: "#006779",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6641 110.109C39.7605 110.478 37.7611 111.032 35.6948 111.828",
    stroke: "#98C6F5",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_30428",
    x1: 149.327,
    y1: 146.954,
    x2: 82.4291,
    y2: -63.3841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01CAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BCE2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D89B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongralutionsImage);
export default __webpack_public_path__ + "static/media/congralutionsImage.43fc444b18939109d3e0954116f4010e.svg";
export { ForwardRef as ReactComponent };